export const avatarClassStyles = theme => ({
  backgroundColor: theme.palette.success.light,
  color: theme.palette.success.dark,
  fontSize: 16,
  height: 24,
  marginRight: theme.spacing(1.5),
  width: 24,
});

export const progressContainerStyles = theme => ({
  boxShadow: theme.shadows[1],
});

export const progressIconStyles = theme => ({
  marginRight: theme.spacing(1.5),
});

export const radioButtonStyles = theme => ({
  '& .MuiFormControlLabel-label': {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  '& label': {
    marginRight: theme.spacing(3),
    width: '100%',
  },
  borderRadius: 24,
  marginTop: theme.spacing(2),
  paddingLeft: theme.spacing(2),
});

export const radioGroupStyles = theme => ({
  marginBottom: theme.spacing(1),
  marginTop: theme.spacing(1),
  width: '100%',
});

export const withVerticalMarginStyles = theme => ({
  margin: `${theme.spacing(2)} 0`,
});
